import { FC } from 'react';
import {
  OGP_IMAGE,
  OGP_SITE,
  OGP_TYPE,
} from '@doda/common/src/constants/properties/arca';
import { Tag } from '@doda/common/src/components/Head/metaTag';
import { TopicJob } from '@doda/pc/src/pages/DodaFront/View/FeaturedJobList/types';
import { getTitle } from './logic/getTitle';
import { getUrl } from './logic/getUrl';
import { getDescription } from './logic/getDescription';
import { getKeyword } from './logic/getKeyword';

/**
 * ヘッドタグコンポーネントに渡されるプロパティを定義するインターフェース
 */
interface Props {
  /** 特集ジョブのタイトル */
  titleText: TopicJob['title'];
  /** 特集のID */
  featuredId: string;
  /** 現在のページ番号 */
  currentPage: number;
  /** 表示開始件数 */
  fromCount: number;
  /** 表示終了件数 */
  toCount: number;
  /** ロボットへのインデックス設定 */
  isRobots: boolean;
  /** 合計件数 */
  totalCount: number;
}

/**
 * ヘッドタグコンポーネント
 *
 * @param {Props} props - プロパティ
 * @returns React要素
 */
export const HeadTag: FC<Props> = ({
  titleText,
  featuredId,
  currentPage,
  fromCount,
  toCount,
  isRobots,
  totalCount,
}) => {
  const title = getTitle({ title: titleText, currentPage });
  const url = getUrl({ featuredId, currentPage });
  const description = getDescription({
    title: titleText,
    currentPage,
    fromCount,
    toCount,
  });
  const keyword = getKeyword({
    title: titleText,
    currentPage,
    fromCount,
    toCount,
  });
  const robots = isRobots ? 'NOINDEX' : undefined;
  const canonical = totalCount === 0 ? undefined : url;

  return (
    <Tag
      title={title}
      description={description}
      keywords={keyword}
      type={OGP_TYPE}
      image={OGP_IMAGE}
      url={url}
      canonical={canonical}
      siteName={OGP_SITE}
      robots={robots}
    />
  );
};
